<template>
    <div
        id="amzn-buy-now"
        data-site-id="4m3vmlnnzi"
        data-widget-id="w-WqfrwRw7Ht64UJt2srcrF3"
        :data-sku="productId"
    ></div>
</template>

<script setup lang="ts">
defineProps<{
    productId?: number;
}>();

const script = document.createElement("script");
script.setAttribute("src", "https://code.buywithprime.amazon.com/bwp.js");
script.async = true;
// Standard IDL property (camelCase). The Options API original assigned the
// non-standard lowercase `fetchpriority`, an inert expando that never reached
// the DOM, so the "high" hint now applies as intended.
script.fetchPriority = "high";
document.head.appendChild(script);
</script>
